export class VKVideoPlayer {
  playersList = {};

  constructor(options) {
    const {
      videoElements,
      handlePlayButtonClick,
      handleWindowScroll,
      handleFormSend,
      handleOpenModal,
      handleCloseModal,
      playButtonSelector = null,
    } = options;

    this.videoElements = document.querySelectorAll(videoElements);
    this.playButtonSelector = playButtonSelector;

    this.handlePlayButtonClick = handlePlayButtonClick;
    this.handleWindowScroll = handleWindowScroll;
    this.handleOpenModal = handleOpenModal;
    this.handleFormSend = handleFormSend;
    this.handleCloseModal = handleCloseModal;
    this.initListener();
  }

  async init() {
    await this.initVKVideoApi();
    await this.populatePlayersList();
  }

  initVKVideoApi() {
    return new Promise((resolve) => {
      const tag = document.createElement('script');
      tag.src = 'https://vk.com/js/api/videoplayer.js';
      tag.onload = resolve;
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    });
  }

  populatePlayersList() {
    this.videoElements.forEach((item, index) => {
      const video = item?.querySelector('.js-vk-video');

      this.playersList[`player-${index}`] = new VK.VideoPlayer(video);
    });
  }

  initListener() {
    if (this.handlePlayButtonClick) {
      document.addEventListener('click', (e) => {
        const videoWrapper = e.target.closest('.js-video');
        const button = e.target.closest(this.playButtonSelector);
        const videoId = videoWrapper?.dataset.videoId;

        if (button) {
          this.handlePlayButtonClick(button, this.playersList, videoId);
        }
      });
    }

    if (this.handleWindowScroll) {
      window.addEventListener('scroll', () => {
        if (this.playButtonSelector) {
          const buttons = document.querySelectorAll(this.playButtonSelector);

          buttons.forEach((button) => {
            const videoWrapper = button.closest('.js-video');
            const videoId = videoWrapper?.dataset.videoId;

            this.handleWindowScroll(button, this.playersList, videoId);
          });
        }
      });
    }

    if (this.handleFormSend) {
      document.addEventListener('form-send', (e) => this.handleFormSend(e, this.playersList));
    }

    if (this.handleOpenModal) {
      document.addEventListener('open-modal', (e) => this.handleOpenModal(e, this.playersList));
    }

    if (this.handleCloseModal) {
      document.addEventListener('close-modal', (e) => this.handleCloseModal(e, this.playersList));
    }
  }
}
